import React from 'react';

function Header() {
  return (
    <header>
      <h1>Shabab Rob Chowdhury</h1>
    </header>
  );
}

export default Header;
